import { Modal, Pagination, Skeleton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { BackButton } from "../buttons";
import { useSelector } from "react-redux";
import { selectWidth } from "../../Redux/profile";
import Fade from "@mui/material/Fade";
import GeniusAlphatecKeyboard from "../geniusAlphatecKeyboard";
import { selectSpinnerLoading } from "../../Redux/modal";
import "./grd.css";
import { FontSizeWidth } from "../../constant";

const MasterHelp = ({
  status,
  style,
  currentPage,
  filterTag,
  searchPlaceHolder,
  onFilterClear,
  title,
  hideFooter,
  onClose,
  rowId,
  list,
  columns,
  onRowClick,
  searchQuery,
  setSearchQuery,
  loading,
  CreateNew,
  extraFilter,
  goToMaster,
  totalPages,
  onChangePagination,
  multiSelect = false, // New prop for multi-select mode
  onSelectionChange, // Callback for multi-select changes
  isRowDisabled, // Function to determine if a row should be disabled: (row) => boolean
  getDisabledReason, // Function to get reason why row is disabled: (row) => string
}) => {
  const headerRef = useRef(null);
  const windowWidth = useSelector(selectWidth);
  const spinerLoading = useSelector(selectSpinnerLoading);
  const [selectedRow, setSelectedRow] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]); // For multi-select mode
  const [hoveredDisabledRow, setHoveredDisabledRow] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  // Helper function to check if a row is disabled
  const checkRowDisabled = (row) => {
    return multiSelect && isRowDisabled ? isRowDisabled(row) : false;
  };

  // Helper function to get disabled reason
  const getRowDisabledReason = (row) => {
    if (multiSelect && getDisabledReason && checkRowDisabled(row)) {
      return getDisabledReason(row);
    }
    return null;
  };

  const handleKeyDown = (event) => {
    // its work using datgrid id
    if (event.key === "ArrowUp") {
      // Handle moving selection up
      event.preventDefault();
      setSelectedRow((prevSelectedRow) => {
        const index = prevSelectedRow ? prevSelectedRow - 1 : list.length - 1;
        return index >= 0 ? index : null;
      });
    } else if (event.key === "ArrowDown") {
      // Handle moving selection down
      event.preventDefault();
      setSelectedRow((prevSelectedRow) => {
        const index = prevSelectedRow !== null ? prevSelectedRow + 1 : 1;

        return index - 1 < list.length ? index : 1;
      });
    } else if (event.key === "Enter") {
      // Handle Enter key press
      if (multiSelect && selectedRows.length > 0) {
        // In multi-select mode, call with all selected rows
        const selectedData = list.filter((item) =>
          selectedRows.includes(item[rowId] || item.id)
        );
        onRowClick && onRowClick({ rows: selectedData });
        setSelectedRows([]);
      } else if (selectedRow !== null && list[0]) {
        // Call your function here with the selected row
        onRowClick({
          row: {
            ...list[selectedRow - 1],
          },
        });
        setSelectedRow(1);
      }
    } else if (event.key === " " && multiSelect) {
      // Space key to toggle selection in multi-select mode
      event.preventDefault();
      if (selectedRow !== null && list[selectedRow - 1]) {
        const currentRow = list[selectedRow - 1];

        // Check if row is disabled
        if (checkRowDisabled(currentRow)) {
          return; // Don't toggle if disabled
        }

        const rowIdValue = currentRow[rowId] || currentRow.id;
        setSelectedRows((prev) => {
          const newSelection = prev.includes(rowIdValue)
            ? prev.filter((id) => id !== rowIdValue)
            : [...prev, rowIdValue];

          // Call selection change callback
          if (onSelectionChange) {
            const selectedData = list.filter((item) =>
              newSelection.includes(item[rowId] || item.id)
            );
            onSelectionChange(selectedData);
          }

          return newSelection;
        });
      }
    }
  };

  const handleSelectionModelChange = (newSelection) => {
    if (multiSelect) {
      // Filter out disabled rows from selection
      const validSelection = newSelection.filter((id) => {
        const row = list.find((item) => (item[rowId] || item.id) === id);
        return row && !checkRowDisabled(row);
      });

      setSelectedRows(validSelection);

      // Call selection change callback
      if (onSelectionChange) {
        const selectedData = list.filter((item) =>
          validSelection.includes(item[rowId] || item.id)
        );
        onSelectionChange(selectedData);
      }
    }
  };

  useEffect(() => {
    if (
      status &&
      (!title.includes("Item") ||
        !window.location.pathname.includes("purchase"))
    ) {
      document.addEventListener("keydown", handleKeyDown);

      // Cleanup function to remove event listener
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    } else {
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [selectedRow, selectedRows, status, list]); // R

  const width = useSelector(selectWidth);

  return (
    <Modal
      open={status}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade
        in={status}
        style={{
          transitionDelay: status ? "100ms" : "0ms",
        }}
      >
        <div style={style}>
          <div className="w-full flex flex-col bg-white h-full ">
            <div ref={headerRef}>
              <div
                style={{
                  border: "1px solid black",
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                  overflow: "hidden",
                  borderBottom: "0px",
                }}
                className="flex flex-col bg-white Fade"
              >
                <div
                  style={{
                    fontSize: FontSizeWidth(width),
                  }}
                  className="font-semibold text-[#4a4a4a] bg-[#f5f0e8] font-arial p-3"
                >
                  {title}
                  {multiSelect && selectedRows.length > 0 && (
                    <span className="ml-2 text-sm text-orange-600">
                      ({selectedRows.length} selected)
                    </span>
                  )}
                </div>
              </div>
            </div>
            {filterTag && (
              <div className="bg-[#f5f0e8] flex border-l p-1  border-r  border-black">
                <div className="  py-[6px] px-3  flex bg-[#f8d9c9] w-fit rounded-sm">
                  <div className="text-[14px]">{filterTag}</div>
                  <button onClick={onFilterClear}>
                    <i className="bi ml-1  bi-x-lg text-[13px] flex items-center text-red-500 "></i>
                  </button>
                </div>
              </div>
            )}

            <div
              style={{
                height: headerRef.current
                  ? `calc(100% - ${headerRef.current.clientHeight}px)`
                  : "80%",
                border: "1px solid black",
                borderBottom: "0px",
              }}
              className="t:flex "
            >
              <div className="h-full ">
                <div
                  style={{
                    height: `calc(100% - ${38}px)`,
                    width:
                      columns.reduce((acc, row) => acc + Number(row.width), 0) +
                      20 + (multiSelect ? 50 : 0), // Add space for checkbox column
                  }}
                  onKeyDown={handleKeyDown}
                  tabIndex={0}
                >
                  {!spinerLoading ? (
                    <>
                    <DataGrid
                      onRowClick={!multiSelect ? onRowClick : undefined}
                      checkboxSelection={multiSelect}
                      onSelectionModelChange={handleSelectionModelChange}
                      isRowSelectable={(params) => {
                        // Disable row selection based on custom logic
                        return !checkRowDisabled(params.row);
                      }}
                      onCellMouseEnter={(params, event) => {
                        // Show tooltip for disabled rows
                        if (params.field === "__check__" && checkRowDisabled(params.row)) {
                          const reason = getRowDisabledReason(params.row);
                          if (reason) {
                            setHoveredDisabledRow(params.id);
                            setTooltipPosition({
                              x: event.clientX,
                              y: event.clientY
                            });
                          }
                        }
                      }}
                      onCellMouseLeave={(params) => {
                        if (params.field === "__check__") {
                          setHoveredDisabledRow(null);
                        }
                      }}
                      hideFooter={list.length < 100 && !currentPage}
                      headerHeight={0}
                      rowHeight={30}
                      hideFooterSelectedRowCount
                      showCellRightBorder={true}
                      showColumnRightBorder={true}
                      disableColumnMenu={true}
                      getRowId={rowId}
                      loading={loading}
                      selectionModel={
                        multiSelect
                          ? selectedRows
                          : selectedRow !== null
                          ? [selectedRow]
                          : []
                      }
                      components={{
                        Header: () => {
                          const headerDetails = columns;

                          return (
                            <div
                              style={{
                                borderBottom: "1px solid black",
                              }}
                              className="bg-[#f5f0e8] flex"
                            >
                              {multiSelect && (
                                <div
                                  className="text-#4a4a4a flex justify-center items-center py-2"
                                  style={{
                                    width: 50,
                                    borderRight: "1px solid black",
                                    fontSize: FontSizeWidth(width),
                                  }}
                                >
                                  Select
                                </div>
                              )}
                              {headerDetails?.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="text-#4a4a4a flex justify-center items-center py-2"
                                    style={
                                      item.flex
                                        ? index < headerDetails.length - 1
                                          ? {
                                              flex: item.flex,
                                              borderRight: "1px solid black",
                                              fontSize: FontSizeWidth(width),
                                            }
                                          : {
                                              flex: item.flex,
                                              fontSize: FontSizeWidth(width),
                                            }
                                        : index < headerDetails.length - 1
                                        ? {
                                            width: item.width,
                                            borderRight:
                                              item.width > 0
                                                ? "1px solid black"
                                                : "0px solid black",
                                            fontSize: FontSizeWidth(width),
                                          }
                                        : {
                                            width: item.width,
                                            fontSize: FontSizeWidth(width),
                                          }
                                    }
                                  >
                                    {item.renderHeader()}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        },

                        NoRowsOverlay: () => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              No Records Found
                            </div>
                          );
                        },
                        Pagination: () => {
                          return (
                            <div className="flex justify-end">
                              <Pagination
                                page={currentPage}
                                count={totalPages}
                                onChange={(e, value) => {
                                  onChangePagination(value);
                                }}
                                sx={{
                                  "& .MuiPaginationItem-root": {
                                    color: "#000",
                                    backgroundColor: "#f3f4f6", // light gray
                                    borderRadius: "8px", // rounded rectangle
                                    margin: "0 4px",
                                    minWidth: "36px",
                                    height: "36px",
                                  },
                              
                                  "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#e5e7eb",
                                  },
                              
                                  "& .Mui-selected": {
                                    backgroundColor: "#000 !important",
                                    color: "#fff !important",
                                  },
                              
                                  "& .Mui-selected:hover": {
                                    backgroundColor: "#000",
                                  },
                                }}
                              />
                            </div>
                          );
                        },
                      }}
                      sx={
                        window.innerWidth < 770
                          ? {
                              backgroundColor: "white",
                              fontSize: FontSizeWidth(width),

                              "& .super-app-theme--header": {
                                backgroundColor: "#f5f0e8",
                                display: "none",
                              },
                              borderRadius: 0,
                              "& .Mui-selected-row": {
                                // Override selected row styles
                                backgroundColor: "blue", // Change background color to blue
                                color: "white", // Change text color to white
                              },
                              "& .MuiDataGrid-row.Mui-disabled": {
                                opacity: 0.5,
                                backgroundColor: "#f5f5f5",
                                pointerEvents: "none",
                              },
                              "& .MuiCheckbox-root.Mui-disabled": {
                                color: "#cccccc",
                                position: "relative",
                                "&::before": {
                                  content: '"🔒"',
                                  position: "absolute",
                                  fontSize: "14px",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 1,
                                },
                                "& .MuiSvgIcon-root": {
                                  opacity: 0.3,
                                },
                              },
                              // Custom checkbox styling
                              "& .MuiCheckbox-root": {
                                color: "#ff6b35", // Orange/red color for unchecked
                                padding: "4px",
                                "&.Mui-checked": {
                                  color: "#ef4444", // Red color when checked
                                },
                                "&:hover": {
                                  backgroundColor: "rgba(239, 68, 68, 0.08)",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "20px",
                                },
                              },
                              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                                color: "#ff6b35",
                                "&.Mui-checked": {
                                  color: "#ef4444",
                                },
                              },
                            }
                          : {
                              backgroundColor: "white",
                              fontSize: FontSizeWidth(width),

                              borderBottom: "0px solid black",
                              borderRadius: 0,
                              "& .super-app-theme--header": {
                                backgroundColor: "#f5f0e8",
                                display: "none",
                              },
                              "& .MuiDataGrid-row.Mui-disabled": {
                                opacity: 0.5,
                                backgroundColor: "#f5f5f5",
                                pointerEvents: "none",
                              },
                              "& .MuiCheckbox-root.Mui-disabled": {
                                color: "#cccccc",
                                position: "relative",
                                "&::before": {
                                  content: '"Paid"',
                                  position: "absolute",
                                  fontSize: "14px",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 1,
                                },
                                "& .MuiSvgIcon-root": {
                                  opacity: 0.3,
                                },
                              },
                              // Custom checkbox styling
                              "& .MuiCheckbox-root": {
                                color: "#ff6b35", // Orange/red color for unchecked
                                padding: "4px",
                                "&.Mui-checked": {
                                  color: "#ef4444", // Red color when checked
                                },
                                "&:hover": {
                                  backgroundColor: "rgba(239, 68, 68, 0.08)",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "20px",
                                },
                              },
                              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                                color: "#ff6b35",
                                "&.Mui-checked": {
                                  color: "#ef4444",
                                },
                              },
                            }
                      }
                      getRowClassName={(params) =>
                        params.isSelected ? "Mui-selected-row" : ""
                      }
                      rowClassName={(params) =>
                        params.isSelected ? "Mui-selected-row" : ""
                      }
                      columns={columns}
                      rows={list}
                      pageSize={100}
                      rowsPerPageOptions={[100]}
                      experimentalFeatures={{ newEditingApi: true }}
                      disableColumnSelector
                      disableColumnReorder
                    />
                    {/* Tooltip for disabled rows */}
                    {hoveredDisabledRow && (() => {
                      const disabledRow = list.find(
                        (item) => (item[rowId] || item.id) === hoveredDisabledRow
                      );
                      const reason = disabledRow ? getRowDisabledReason(disabledRow) : null;
                      
                      return reason ? (
                        <div
                          style={{
                            position: 'fixed',
                            left: tooltipPosition.x + 10,
                            top: tooltipPosition.y - 40,
                            zIndex: 10000,
                            pointerEvents: 'none',
                          }}
                        >
                          <div className="bg-red-500 text-white px-3 py-2 rounded shadow-lg text-sm flex items-center gap-2 max-w-xs">
                            <i className="bi bi-lock"></i>
                            <span>{reason}</span>
                          </div>
                        </div>
                      ) : null;
                    })()}
                    </>
                  ) : (
                    <div className="w-full ">
                      <div className="flex w-full ">
                        {multiSelect && (
                          <Skeleton
                            width={50}
                            height={60}
                            style={{
                              marginLeft: 3,
                            }}
                          />
                        )}
                        {columns.map((e, i) => {
                          return (
                            <Skeleton
                              key={i}
                              width={e.width}
                              height={60}
                              style={{
                                marginLeft: 3,
                              }}
                            />
                          );
                        })}
                      </div>
                      <div>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e, key) => {
                          return (
                            <div key={key} className="flex ">
                              {multiSelect && (
                                <Skeleton
                                  width={50}
                                  height={50}
                                  style={{
                                    marginLeft: 3,
                                  }}
                                />
                              )}
                              {columns.map((e, i) => {
                                return (
                                  <Skeleton
                                    key={i}
                                    width={e.width}
                                    height={50}
                                    style={{
                                      marginLeft: 3,
                                    }}
                                  >
                                    {" "}
                                  </Skeleton>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex flex-1 items-center">
                  <div
                    style={{
                      border: "0px solid black",

                      fontSize: "14px",
                      backgroundColor: "#f5f0e8",
                    }}
                    className="flex px-2 flex-1 py-2 items-center "
                  >
                    <i className="bi bi-search pr-2 text-orange"></i>
                    <input
                      type={"text"}
                      placeholder={
                        searchPlaceHolder ? searchPlaceHolder : "Search"
                      }
                      value={searchQuery}
                      {...(window.innerWidth > 1280 && { autoFocus: true })}
                      onChange={(t) => {
                        setSearchQuery(t.target.value);
                      }}
                      onFocus={(e) => {
                        e.stopPropagation();
                      }}
                      style={{
                        width: extraFilter
                          ? extraFilter[0].firstWidth - 150
                          : "100%",
                      border: "0px solid black",
                      outline:'none'
                      }}
                      className="  h-full bg-[#f5f0e8] text-[#4a4a4a]"
                    />
                  </div>

                  <div className=" flex  ">
                    {extraFilter
                      ? extraFilter.map((o, key) => {
                          return (
                            <div key={key}>
                              <input
                                value={o.value}
                                type={"text"}
                                placeholder={o.placeHolder}
                                onChange={(t) => {
                                  o.onChange(t.target.value);
                                }}
                                style={{
                                  width: o.width,
                                }}
                                className="pl-2 border-l p-2 border-l-[#c7c6c5] bg-[#F5F0E8] outline-0  text-[#4a4a4a]"
                              />
                            </div>
                          );
                        })
                      : null}
                  </div>
                  {CreateNew && (
                    <button
                      onClick={CreateNew}
                      className=" text-sm text-white shadow-sm  ml-1 mr-1 bg-red-500  p-2 rounded-r-sm flex items-center "
                    >
                      Create New
                    </button>
                  )}
                </div>

                {/* Continue button for multi-select mode */}
                {multiSelect && (
                  <div
                    style={{
                      backgroundColor: "#f5f0e8",
                      borderTop: "1px solid #c7c6c5",
                    }}
                    className="flex items-center justify-between px-4 py-3"
                  >
                    <div className="text-sm text-[#4a4a4a]">
                      {selectedRows.length > 0 ? (
                        <span>
                          <i className="bi bi-check-circle-fill text-green-600 mr-2"></i>
                          {selectedRows.length} item{selectedRows.length !== 1 ? "s" : ""} selected
                        </span>
                      ) : (
                        <span className="text-gray-500">
                          <i className="bi bi-info-circle mr-2"></i>
                          Select items using checkboxes or press Space on highlighted row
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => {
                        const selectedData = list.filter((item) =>
                          selectedRows.includes(item[rowId] || item.id)
                        );
                        onRowClick && onRowClick({ rows: selectedData });
                        setSelectedRows([]);
                      }}
                      disabled={selectedRows.length === 0}
                      className={`text-sm font-semibold px-6 py-2 rounded shadow-sm flex items-center gap-2 ${
                        selectedRows.length > 0
                          ? "bg-green-600 hover:bg-green-700 text-white cursor-pointer"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    >
                      Continue
                      <i className="bi bi-arrow-right"></i>
                    </button>
                  </div>
                )}
              </div>
              {windowWidth <= 1280 && windowWidth >= 1024 && (
                <div className=" h-full border   flex flex-col ">
                  <div className=" w-full flex justify-center  flex-col grow items-center  ">
                    {/* <img src={tailoringLogo} className="w-44 flex" /> */}
                    {/* <RetailxLogo /> */}
                  </div>

                  <div className="  justify-end">
                    <GeniusAlphatecKeyboard
                      text={searchQuery}
                      setText={setSearchQuery}
                      onEnter={() => {
                        setSearchQuery("");

                        onRowClick({ row: list[0] });
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                borderTop: "1px dotted black",
                borderLeft: "1px dotted black",
                borderRight: "1px dotted black",
                borderBottom: "1px dotted black",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
              }}
              className="w-full flex justify-end p-2 bg-white  "
            >
              {multiSelect && selectedRows.length > 0 && (
                <button
                  onClick={() => {
                    const selectedData = list.filter((item) =>
                      selectedRows.includes(item[rowId] || item.id)
                    );
                    onRowClick && onRowClick({ rows: selectedData });
                    setSelectedRows([]);
                  }}
                  className="mr-2 text-sm text-white shadow-sm bg-brown px-4 py-2 rounded"
                >
                  Confirm Selection ({selectedRows.length})
                </button>
              )}
              {multiSelect && selectedRows.length > 0 && (
                <button
                  onClick={() => setSelectedRows([])}
                  className="mr-2 text-sm text-black shadow-sm bg-orange px-4 py-2 rounded"
                >
                  Clear Selection
                </button>
              )}
              {
                <BackButton
                  onClick={() => {
                    onClose();
                    setSearchQuery("");
                    setSelectedRows([]);
                  }}
                />
              }
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default MasterHelp;